/* eslint-disable import/prefer-default-export */
import React, { forwardRef } from 'react';
import {
  Search,
  Clear,
  FirstPage,
  ChevronLeft,
  ChevronRight,
  LastPage,
  ArrowDropUp
} from '@material-ui/icons';


export const tableIcons = {
  FirstPage: forwardRef((props, ref) => (
    <FirstPage className="opaque-icon" ref={ref} />
  )),
  LastPage: forwardRef((props, ref) => (
    <LastPage className="opaque-icon" ref={ref} />
  )),
  NextPage: forwardRef((props, ref) => (
    <ChevronRight className="opaque-icon" ref={ref} />
  )),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft className="opaque-icon" ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear ref={ref} />),
  Search: forwardRef((props, ref) => <Search ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDropUp ref={ref} />)
};